import { useSyncExternalStore } from "react";
import {
  getPwaInstallState,
  promptInstall,
  subscribePwaInstall,
} from "@/lib/pwa-install";

export type { PwaPlatform } from "@/lib/pwa-install";

/**
 * PWA install state for the settings Install App section and the install
 * banner. Read from the app-wide store in `@/lib/pwa-install`, which listens
 * for `beforeinstallprompt` from app start: the event can fire before any
 * component mounts, and a screen that mounts late still finds it held in
 * `installEvent`. `install()` shows the native prompt and resolves to the
 * user's choice (null when no event is held).
 */
export function usePwaInstall() {
  const { platform, isStandalone, installEvent, installed } =
    useSyncExternalStore(subscribePwaInstall, getPwaInstallState);

  return { platform, isStandalone, installEvent, installed, install: promptInstall };
}
